var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 1.3335V5.3335C8.00004 5.7015 8.29804 6.00016 8.66671 6.00016H12.6667V13.3335C12.6667 14.0695 12.0694 14.6668 11.3334 14.6668H4.66671C3.93071 14.6668 3.33337 14.0695 3.33337 13.3335V2.66683C3.33337 1.93083 3.93071 1.3335 4.66671 1.3335H8.00004ZM9.33344 1.3337C9.34477 1.34436 9.35877 1.35236 9.37077 1.3637L12.6361 4.6297L12.6668 4.66703H9.33344V1.3337Z",
    fill: "#FF6200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFilled);
export default __webpack_public_path__ + "static/media/document-filled.6d3408f130fde83cf37467a226758ad0.svg";
export { ForwardRef as ReactComponent };